import {
  Accordion,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useColorModeValue
} from "@chakra-ui/react";
import { ClientClassificationType } from "models/client_classification_type";
import { ContatoType } from "models/contato_type";
import { EmpresaFilial } from "models/empresa_filial_type";
import { EnderecoType } from "models/endereco_type";
import { PessoaType } from "models/person_type";
import { PessoaContaFinanceiro } from "models/pessoa_conta_type";
import { ViaCepType } from "models/via_cep_type";
import AddressData from "./AddressData";
import ContactData from "./ContactData";
import ContaFinanceiroData from "./ContaFinaceiroData";
import PersonalData from "./PersonalData";

interface IFormClient {
  showModal: (show: boolean) => void;
  show: boolean;
  accountSelected: PessoaType | undefined;
  error: boolean;
  nomeRef: any;
  textColor: any;
  brandStars: any;
  save: () => void;
  loading: boolean;
  idTipoRef: any;
  classificacaoRef: any;
  documentoRef: any;
  razaoSocialRef: any;
  nomeFantasiaRef: any;
  inscricaoMunicipalRef: any;
  inscricaoEstadualRef: any;
  contribuinteRef: any;
  tipoPessoaList: ClientClassificationType[];
  classificacaoList: ClientClassificationType[];
  cepRef: any;
  ruaRef: any;
  numeroRef: any;
  complementoRef: any;
  bairroRef: any;
  cidadeRef: any;
  estadoRef: any;
  principalRef: any;
  enderecoList: EnderecoType[];
  viaCepEnd: ViaCepType;
  loadCEP: (cep: string) => void;
  adicionarEnd: () => void;
  deleteEnd: (end: EnderecoType) => void;
  contatoList: ContatoType[];
  cargoContatoRef: any;
  emailContatoRef: any;
  nomeContatoRef: any;
  principalContatoRef: any;
  telefoneContatoRef: any;
  deleteContato: (contato: ContatoType) => void;
  adicionarContato: () => void;
  changeItem: (item: ContatoType, index: number) => void;
  filial: PessoaType[];
  changeFilial: (item: any) => void;
  pessoaFilial: EmpresaFilial[];
  contaList: PessoaContaFinanceiro[];
  deleteConta: (conta: PessoaContaFinanceiro) => void;
  adcionarConta: () => void;
  bancoRef: any;
  agenciaRef: any;
  tipoRef: any;
  numeroContaRef: any;
  titularRef: any;
  tipoPessoaRef: any;
  documentoContaRef: any;
  descricaoRef: any;
  obsRef: any;
}

const FormClient = ({
  showModal,
  show,
  accountSelected,
  error,
  nomeRef,
  save,
  loading,
  classificacaoRef,
  contribuinteRef,
  documentoRef,
  idTipoRef,
  inscricaoEstadualRef,
  inscricaoMunicipalRef,
  nomeFantasiaRef,
  razaoSocialRef,
  tipoPessoaList,
  classificacaoList,
  bairroRef,
  cepRef,
  cidadeRef,
  complementoRef,
  estadoRef,
  numeroRef,
  principalRef,
  ruaRef,
  enderecoList,
  loadCEP,
  viaCepEnd,
  adicionarEnd,
  deleteEnd,
  contatoList,
  deleteContato,
  adicionarContato,
  cargoContatoRef,
  emailContatoRef,
  nomeContatoRef,
  principalContatoRef,
  telefoneContatoRef,
  changeItem,
  filial,
  changeFilial,
  pessoaFilial,
  contaList,
  bancoRef,
  agenciaRef,
  tipoRef,
  numeroContaRef,
  titularRef,
  tipoPessoaRef,
  documentoContaRef,
  descricaoRef,
  obsRef,
  deleteConta,
  adcionarConta,
}: IFormClient) => {
  const textColor = useColorModeValue("navy.700", "white");
  const brandStars = useColorModeValue("brand.500", "brand.400");

  return (
    <Modal
      onClose={() => {
        showModal(false);
      }}
      size={"full"}
      isOpen={show}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          {accountSelected !== undefined && accountSelected !== null
            ? "Editar Pessoa"
            : "Novo Cadastro de Pessoa"}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Accordion defaultIndex={[0]} allowMultiple>
            <PersonalData
              classificacaoList={classificacaoList}
              tipoPessoaList={tipoPessoaList}
              brandStars={brandStars}
              error={error}
              nomeRef={nomeRef}
              textColor={textColor}
              accountSelected={accountSelected}
              idTipoRef={idTipoRef}
              classificacaoRef={classificacaoRef}
              documentoRef={documentoRef}
              razaoSocialRef={razaoSocialRef}
              nomeFantasiaRef={nomeFantasiaRef}
              inscricaoMunicipalRef={inscricaoMunicipalRef}
              inscricaoEstadualRef={inscricaoEstadualRef}
              contribuinteRef={contribuinteRef}
              filial={filial}
              changeFilial={changeFilial}
              pessoaFilial={pessoaFilial}
            />
            <AddressData
              loadCEP={loadCEP}
              viaCepEnd={viaCepEnd}
              list={enderecoList}
              bairroRef={bairroRef}
              textColor={textColor}
              cepRef={cepRef}
              ruaRef={ruaRef}
              numeroRef={numeroRef}
              complementoRef={complementoRef}
              cidadeRef={cidadeRef}
              estadoRef={estadoRef}
              principalRef={principalRef}
              adicionarEnd={adicionarEnd}
              deleteEnd={deleteEnd}
            />
            <ContactData
              contatoList={contatoList}
              textColor={textColor}
              deleteContact={deleteContato}
              adicionarContact={adicionarContato}
              nomeContatoRef={nomeContatoRef}
              cargoContatoRef={cargoContatoRef}
              telefoneContatoRef={telefoneContatoRef}
              emailContatoRef={emailContatoRef}
              principalContatoRef={principalContatoRef}
              changeItem={changeItem}
            />
            <ContaFinanceiroData
              adcionarConta={adcionarConta}
              agenciaRef={agenciaRef}
              bancoRef={bancoRef}
              contaList={contaList}
              deleteConta={deleteConta}
              descricaoRef={descricaoRef}
              documentoContaRef={documentoContaRef}
              numeroContaRef={numeroContaRef}
              obsRef={obsRef}
              tipoPessoaRef={tipoPessoaRef}
              tipoRef={tipoRef}
              titularRef={titularRef}
              textColor={textColor}
            />
          </Accordion>
        </ModalBody>
        <ModalFooter>
          <Button
            onClick={() => {
              showModal(false);
            }}
            variant="outline"
            marginRight={4}
          >
            Fechar
          </Button>
          <Button
            onClick={() => {
              save();
            }}
            colorScheme="brand"
            isLoading={loading}
          >
            Salvar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
export default FormClient;
